import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import Helmet from 'react-helmet'

export default function SEO({ meta = [] }) {
  return (
    <StaticQuery
      query={graphql`
        query {
          meta: contentYaml {
            title
            description
            keywords
          }
        }
      `}
      render={data => (
        <Helmet
          title={data.meta.title}
          meta={[
            {
              name: 'description',
              content: data.meta.description,
            },
            {
              name: 'keywords',
              content: data.meta.keywords.join(','),
            },
          ].concat(meta)}
        >
          <html lang="en" />

          <link rel="canonical" href="https://phonerevealer.com" />

        </Helmet>
      )}
    />
  )
}
